export default __webpack_public_path__ + "static/media/366.83c2d81d.png";